<script setup lang="ts">
import { Toaster } from '~/components/ui/sonner'

// og:image 對 LINE / Facebook / Twitter 需要絕對 URL；用 useRequestURL 讓 SSR / client 都能組出正確 origin
const requestURL = useRequestURL()
const ogImage = `${requestURL.protocol}//${requestURL.host}/logo.png`
const siteName = 'HakkaTV 排播系統'
const siteDescription = 'HakkaTV 客家電視台內部排播系統'

useSeoMeta({
  description: siteDescription,
  ogType: 'website',
  ogSiteName: siteName,
  ogTitle: siteName,
  ogDescription: siteDescription,
  ogImage,
  twitterCard: 'summary',
  twitterTitle: siteName,
  twitterDescription: siteDescription,
  twitterImage: ogImage,
})

// 內部系統，禁止被搜尋引擎索引（對齊 eagle-finance cms/app.vue 做法）
useHead({
  meta: [
    { name: 'robots', content: 'noindex' },
    { name: 'googlebot', content: 'noindex' },
    { name: 'googlebot-news', content: 'noindex' },
    { name: 'googlebot-image', content: 'noindex' },
    { name: 'bingbot', content: 'noindex' },
    { name: 'yandex', content: 'noindex' },
    { name: 'baidu', content: 'noindex' },
  ],
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <!-- Client overlay：Toaster 依 Teleport 到 document.body、SSR 環境無 document；
       vue-sonner 2.x + Vue 3.5 strict SSR checks 撞 `Cannot read properties of null
       (reading 'ce')` (見 hakkatv-schedule-iac vault gotcha
       2026-07-06-iac-onboarding-first-deploy-traps.md trap 12)。
       Toast 本質是 user-action feedback、不需 SSR 首屏、client-only 零損失。 -->
  <ClientOnly>
    <Toaster position="top-right" rich-colors />
  </ClientOnly>
  <!-- 全站相片放大 dialog 的單例掛點，由 usePhotoZoom().open(photo) 觸發 -->
  <PhotoZoomOverlay />
</template>
